import { types } from "../types/types";
const intitalState = {
    allIngredients: [],
};

const ingredientsReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.CHANGE_INGREDIENTS:
            return {
                ...state,
                allIngredients: action.payload,
            };
        default:
            return { ...state };
    }
};

export default ingredientsReducer;
